/* eslint-disable import/prefer-default-export */
export const ModelType = {
  TwoDimensional: '2d',
  ThreeDimensional: '3d',
};

export const ModelFormats = 'STL, OBJ, FBX, COLLADA, 3DS, Glb, glTF';
